<div class="d-flex align-center">
    <h3 class="mr-2">{{ fullname }}</h3>
    <v-menu v-model="isInfoMenuVisible">
        <template v-slot:activator="{ props }">
            <v-icon v-bind="props" size="x-large" color="primary">
                mdi-information-variant
            </v-icon>
        </template>
        <v-list>
            <template v-for="(item, index) in infoMenuItems" :key="index">
                <v-list-item v-if="item.action" @click="item.action">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-else-if="item.href"
                    :href="item.href"
                    target="_blank">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
            </template>
        </v-list>
    </v-menu>
    <v-menu v-model="isAccountMenuVisible">
        <template v-slot:activator="{ props }">
            <v-icon v-bind="props" size="x-large" color="primary">
                mdi-account
            </v-icon>
        </template>
        <v-list>
            <template
                v-for="(item, index) in accountMenuItems"
                :key="index">
                <v-list-item v-if="item.action" @click="item.action">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-else-if="item.href"
                    :href="item.href"
                    target="_blank">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
            </template>
        </v-list>
    </v-menu>
</div>